import { PromangRichTextEditor } from "../../../utils/PromangRichTextEditor";

export const agreementButton = "min-h-[42px] rounded-xl border border-slate-200 px-4 py-2 text-sm font-semibold hover:bg-slate-50 disabled:opacity-50";
export const agreementInput = "mt-1 block w-full rounded-xl border-slate-300 text-sm";

export function AgreementTextField({ label, value, onChange, disabled }) {
  return <div role="group" aria-label={label} className="space-y-2"><span className="block text-sm font-semibold">{label}</span><PromangRichTextEditor value={value} onChange={onChange} disabled={disabled} templatesEnabled size="md" /></div>;
}
